module.exports = __webpack_public_path__ + "img/dialog_info.bbb9572f.svg";